export const URL_CONSTANTS = {
  CHECK_YOUR_INBOX: 'https://support.apty.io/knowledge/check-your-inbox',
  LEARN_HOW_TO_USE_APTY: 'https://support.apty.io/knowledge/what-is-apty-studio',
  LOGIN: 'https://chromewebstore.google.com/detail/apty-assist-studio/ebolcaaclblbeggnplomlceahphnoblh',
  BOOK_A_DEMO: 'https://www.apty.io/book-a-demo/',
  GET_IN_TOUCH: 'https://support.apty.io/knowledge',
}

export const API_RESPONSE_ERROR_CODES = {
  DISPOSABLE_EMAIL: 4,
  PUBLIC_EMAIL: 5,
  INVALID_EMAIL_ADDRESS: 6,
  PREMIUM_ACCOUNT_EXISTS: 7,
  EXPIRED: 8,
  ALREADY_EXISTS: 9
}
